/* @flow */

import * as types from './uiMarketActionTypes';

import {
  convertSlackSharingToNotification,
  convertFavoriteTutorialToNotification,
} from 'src/shared/app/market/util/marketUtils';
import { queueNotification } from 'src/shared/app/notification/action/uiNotificationActions';

export function startHidingMarketMenu() {
  return {
    type: types.START_HIDING_MARKET_MENU,
  };
}

export function showMarketQueryMenu() {
  return {
    type: types.SHOW_MARKET_QUERY_MENU,
  };
}

export function hideMarketQueryMenu() {
  return {
    type: types.HIDE_MARKET_QUERY_MENU,
  };
}

export function showMarketFilterMenu() {
  return {
    type: types.SHOW_MARKET_FILTER_MENU,
  };
}

export function hideMarketFilterMenu() {
  return {
    type: types.HIDE_MARKET_FILTER_MENU,
  };
}

export function showMarketSortMenu() {
  return {
    type: types.SHOW_MARKET_SORT_MENU,
  };
}

export function hideMarketSortMenu() {
  return {
    type: types.HIDE_MARKET_SORT_MENU,
  };
}

export function showMarketAutocomplete() {
  return {
    type: types.SHOW_MARKET_AUTOCOMPLETE,
  };
}

export function hideMarketAutocomplete() {
  return {
    type: types.HIDE_MARKET_AUTOCOMPLETE,
  };
}

export function dismissMarketTopicNotFoundError() {
  return {
    type: types.DISMISS_MARKET_TOPIC_NOT_FOUND,
  };
}

export function setMarketFirstTopic(topicId: number) {
  return {
    type: types.SET_MARKET_FIRST_TOPIC,
    topicId,
  };
}

export function resetMarketFirstTopic() {
  return {
    type: types.RESET_MARKET_FIRST_TOPIC,
  };
}

export function freezeMarketTopics() {
  return {
    type: types.FREEZE_MARKET_TOPICS,
  };
}

export function unfreezeMarketTopics() {
  return {
    type: types.UNFREEZE_MARKET_TOPICS,
  };
}

export function showSlackTopicSharedNotification() {
  return queueNotification(convertSlackSharingToNotification());
}

export function showFavoriteNotification() {
  return queueNotification(convertFavoriteTutorialToNotification());
}

export function hideAddInterestsPrompt() {
  return {
    type: types.HIDE_ADD_INTERESTS_PROMPT,
  };
}
